import {
  PaymentExecutionOptions,
  PaymentMethod,
} from '../typing';
import { createContext } from 'react';

export interface PaymentClientContextType {
  prefix?: string;
  defaultOptions: (method: PaymentMethod) => PaymentExecutionOptions;
}

const PaymentClientContext = createContext<PaymentClientContextType>({
  prefix: '',
  defaultOptions: () => {
    return {

    };
  },
});

export default PaymentClientContext;
